import React from 'react';
import { Link } from 'react-router-dom';

const Card = ({ titre, faClassName, children }) => (
    <div className="text-center">
        <i className={`fas fa-5x ${faClassName} mt-3 mb-0`} />
        <div className="m-3">
            <h1>{titre}</h1>
            {children}
        </div>
    </div>
);

export const CardValide = ({ email, children }) => (
    <React.Fragment>
        <Card titre="Succès !" faClassName="fa-check-circle text-success">
            {children}
        </Card>
        <Link
            to={{
                pathname: '/Connexion',
                state: { email },
            }}
            className="btn btn-success btn-lg btn-block"
        >
            OK
        </Link>
    </React.Fragment>
);

export const CardValideNG = ({ Lien, children }) => (
    <React.Fragment>
        <Card titre="Succès !" faClassName="fa-check-circle text-success">
            {children}
        </Card>
        <Link to={Lien} className="btn btn-success btn-lg btn-block">
            OK
        </Link>
    </React.Fragment>
);

export const CardInvalide = ({ Lien, children }) => (
    <React.Fragment>
        <Card titre="Erreur" faClassName="fa-times-circle text-danger">
            {children}
        </Card>
        <Link to={Lien} className="btn btn-danger btn-lg btn-block">
            OK
        </Link>
    </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/Adherent/Cards.js